// import { Row } from 'ant-design-vue'
import viewsSentOrder from '../components/viewPage.vue'
import editUnconfirmedOrder from './../components/editDeliveriesTakedOrder.vue'
// import orderConfirmed from '../components/orderConfirmed.vue'
// import editSentOrder from '../components/editSentOrder.vue'
import store from '../../store'
import vue from 'vue'
import totalPrice from '../components/packAndpallet.vue'
// import saleVerify from './../components/saleVerify.vue'
// import saleVerify1 from './../components/saleVerify1.vue'
// import verifyLog from './../components/verifyLog.vue'
// import NP from 'number-precision'
// import DeleteOrder from './../components/orderDelete.vue'
import orderStatus from '../components/orderStatus.vue'
const that = vue.prototype
export default {
  className: 'Order', // 待一审订单
  title: '待一审订单',
  perPage: 30,
  mixin: {
    fields: [
      // {
      //   name: 'Number'
      // },
      {
        // 所属用户
        name: 'userid',
        note: '销售人员',
        width: 80,
        validators: [
          val => (val) ? null : '所属用户不可为空'
        ]
      },
      {
        name: 'userCompany',
        note: '所属公司',
        width: 80,
        validators: [
          val => (val) ? null : '所属公司不可为空'
        ]
      },
      {
        // 型号
        name: 'finishProductid',
        width: 80,
        validators: [
          val => (val) ? null : '成品型号不可为空'
        ]
      },

      {
        // 包装
        name: 'packid',
        width: 80,
      },
      {
        // 托盘
        name: 'palletid',
        width: 80,
      },
      {
        // 状态
        name: 'status',
        width: 100,
        view: {
          component: orderStatus
        }
      },

      {
        name: 'verifyStatus',
        width: 100,
      },

      {
        // 订单客户
        name: 'clientid',
        width: 110,
      },
      {
        // 吨数
        name: 'amount',
        width: 80,
      },
      // {
      //   // 运费
      //   name: 'shipping',
      //   width: 80,
      // },
      {
        // 每吨运费
        name: 'pricePerTon',
        width: 100,
      },
      {
        // 售价
        name: 'sellingPrice',
        width: 80,
      },
      {
        // 成本
        name: 'costPrice',
        width: 80,
      },
      {
        name: 'palletid.price',
        note: '包装托盘费',
        view: {
          component: totalPrice
        }
      },
      // {
      //   name: 'packid.price',
      //   note: '包装费'
      // },
      {
        // 客户提成
        name: 'clientCommission',
        width: 100,
      },
      {
        name: 'taxRate',
        width: 80,
      },
      {
        // 发出时间
        name: 'sentAt',
        width: 100,
        render: (record) => {
          return that.$tkDate(record.sentAt).format('m-d')
        }
      },
      {
        // 下单日期
        name: 'orderDate',
        width: 100,
        render: (record) => {
          return that.$tkDate(record.orderDate).format('m-d')
        }
      },
      {
        // 交付日期
        name: 'shipDate',
        width: 100,
        render: (record) => {
          return that.$tkDate(record.shipDate).format('m-d')
        }
      },
      {
        // 利润
        name: 'profit',
        width: 80,
        validators: [
          val => (val) ? null : '利润不可为空'
        ],
        hidden: () => true
      },

      {
        // 备注
        name: 'remarks',
        width: 80,
      },

      {
        // 提成
        name: 'commission',
        width: 80,
        validators: [
          val => (val) ? null : '提成不可为空'
        ],
        hidden: () => true
      },
      // {
      //   // 其他费用
      //   name: 'anotherCost'
      // },
      {
        name: 'updatedAt',
        width: 100,
        render: (record) => {
          return that.$tkDate(record.updatedAt).format('m-d')
        }
      }
    ],
  },
  search: [
    'userid',
    'userCompany',
    'finishProductid',
    'orderDate',
    'shipDate'
  ],
  action: {
    create: false,
    // edit: store.state.user && ((store.state.user.adminRole === 'sale') || (store.state.user.adminRole === 'admin'))
    //   ? {
    //     type: 'row',
    //     text: '编辑',
    //     component: editSentOrder
    //   } : false,
    edit: store.state.user && store.state.user.authority.unconfirmedOrder.edit
      ? {
        type: 'row',
        text: '编辑',
        title: '订单编辑',
        component: editUnconfirmedOrder
      } : false,
    view: store.state.user && store.state.user.authority.unconfirmedOrder.view ? {
      type: 'row',
      text: '查看',
      component: viewsSentOrder,
    } : false,
    verify1: store.state.user && store.state.user.authority.unconfirmedOrder.verify1
      ? {
        type: 'row',
        text: '审核',
        callback: async ({ record, vm, modelName }) => {
          await vm.confirm('提示', '确认对此订单进行一次审核？')
          let data = {
            verifyStatus: record.verifyStatus,
            auditor: '',
            verifyDate1: null
          }
          let rs = null
          if (data.verifyStatus === 'noVerify') {
            data.verifyStatus = 'firstVerify'
            data.auditor = store.state.user.name
            data.verifyDate1 = new Date().toISOString()
            try {
              rs = await vm.$modelAjax.put(modelName, record.objectId, data)
            } catch (e) {
              vm.$notification.error({
                message: '网络错误',
                description: '网络错误'
              })
            }
          } else if (data.verifyStatus === 'firstVerify') {
            vm.$notification.error({
              message: '订单已审核',
              description: '此订单已完成一次审核'
            })
          } else {
            vm.$notification.error({
              message: '审核失败',
              description: '此订单不可进行一次审核'
            })
          }
          if (rs) {
            vm.$notification['success']({
              message: '操作成功',
              description: '订单已完成一次审核'
            })
            vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
          }
        }
        // component: saleVerify1
      } : false,
    delete: false
  },
  hooks: {
    beforeFetch ({ where }) {
      // where.status = 'transit'
      where.status = {
        $in: ['transit', 'deliveriesTaked', 'finish']
      }
      where.verifyStatus = {
        $in: ['noVerify']
      }
      where.isReserve = { $ne: true }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
